"use strict";
var globalThis = require("../internals/global-this");
var defineWellKnownSymbol = require("../internals/well-known-symbol-define");
var defineProperty = require("../internals/object-define-property").f;
var getOwnPropertyDescriptor = require("../internals/object-get-own-property-descriptor").f;
var Symbol = globalThis.Symbol;
defineWellKnownSymbol("asyncDispose");
if (Symbol) {
  var descriptor = getOwnPropertyDescriptor(Symbol, "asyncDispose");
  if (descriptor.enumerable && descriptor.configurable && descriptor.writable) {
    defineProperty(Symbol, "asyncDispose", { value: descriptor.value, enumerable: false, configurable: false, writable: false });
  }
}
